export default __webpack_public_path__ + "static/media/SearchIcon.f84536d4.svg";